var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPersonalizedAnc = function SvgIconPersonalizedAnc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_personalized_anc_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.622c-4.97 0-9 3.916-9 8.749a8.5 8.5 0 0 0 1.055 4.114c.13.236.037.53-.206.656a.51.51 0 0 1-.677-.2A9.457 9.457 0 0 1 2 12.37c0-5.366 4.476-9.719 10-9.719s10 4.353 10 9.719a9.46 9.46 0 0 1-1.172 4.57.51.51 0 0 1-.677.2.477.477 0 0 1-.206-.656q.08-.147.155-.296c.576-1.153.9-2.448.9-3.818 0-4.833-4.03-8.749-9-8.749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 14.774c2.21 0 4-1.737 4-3.88 0-2.141-1.79-3.878-4-3.878s-4 1.737-4 3.879 1.79 3.879 4 3.879m0-.97c1.657 0 3-1.303 3-2.91 0-1.606-1.343-2.908-3-2.908s-3 1.302-3 2.909 1.343 2.909 3 2.909",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19.534c0-1.501 1.449-2.821 3.368-2.821h5.264c1.92 0 3.368 1.32 3.368 2.821v.093c0 .268.224.485.5.485s.5-.217.5-.485v-.093c0-2.148-2.018-3.79-4.368-3.79H9.368c-2.35 0-4.368 1.642-4.368 3.79v.088c0 .268.224.485.5.485s.5-.217.5-.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.937 22.046c-.222.837-1.005 1.455-1.937 1.455s-1.715-.618-1.937-1.455H3a.493.493 0 0 1-.5-.485c0-.267.224-.484.5-.484h9.063c.222-.837 1.005-1.455 1.937-1.455s1.715.618 1.937 1.455H21c.276 0 .5.217.5.484a.493.493 0 0 1-.5.485zM14 22.531c.552 0 1-.434 1-.97 0-.535-.448-.97-1-.97s-1 .435-1 .97c0 .536.448.97 1 .97",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_personalized_anc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .713h24v23.273H0z"
  })))));
};
export default SvgIconPersonalizedAnc;